import { EMPTY_LIST } from '../../../constants/common'
import { EXCLUDE_FILTERS } from '../../Filter'

import { ENTITY_TAB_INHABITANTS_SUB_TAB_QA_NAME } from './EntityTabInhabitants.constants'

export function getEntityTabInhabitantsExcludeFilters(scopeFilterKey) {
  return [
    ...EXCLUDE_FILTERS,
    ...(scopeFilterKey ? [scopeFilterKey] : EMPTY_LIST),
  ]
}

export function getEntityTabInhabitantsSubTabQaName(item) {
  return ENTITY_TAB_INHABITANTS_SUB_TAB_QA_NAME[item.value]
}
